/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as QrRouteRouteImport } from './routes/qr/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QrCodeRouteImport } from './routes/qr/$code'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AppShippersRouteImport } from './routes/_app/shippers'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppLoadBoardRouteImport } from './routes/_app/load-board'
import { Route as AppFleetRouteImport } from './routes/_app/fleet'
import { Route as AppDriversRouteImport } from './routes/_app/drivers'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppContactsRouteImport } from './routes/_app/contacts'
import { Route as AppCarriersRouteImport } from './routes/_app/carriers'
import { Route as AppApplyRouteImport } from './routes/_app/apply'
import { Route as AppApplicationStatusRouteImport } from './routes/_app/application-status'
import { Route as AppAddressesRouteImport } from './routes/_app/addresses'
import { Route as AppTripsRouteRouteImport } from './routes/_app/trips/route'
import { Route as AppTicketsRouteRouteImport } from './routes/_app/tickets/route'
import { Route as AppLoadsRouteRouteImport } from './routes/_app/loads/route'
import { Route as AppAccountRouteRouteImport } from './routes/_app/account/route'
import { Route as AppTripsIndexRouteImport } from './routes/_app/trips/index'
import { Route as AppTicketsIndexRouteImport } from './routes/_app/tickets/index'
import { Route as AppNegotiationsIndexRouteImport } from './routes/_app/negotiations/index'
import { Route as AppLoadsIndexRouteImport } from './routes/_app/loads/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as LoadsIdAgreementRouteImport } from './routes/loads/$id/agreement'
import { Route as AppTripsShipperRouteImport } from './routes/_app/trips/shipper'
import { Route as AppTripsCarrierRouteImport } from './routes/_app/trips/carrier'
import { Route as AppTripsIdRouteImport } from './routes/_app/trips/$id'
import { Route as AppTicketsIdRouteImport } from './routes/_app/tickets/$id'
import { Route as AppNegotiationsSentRouteImport } from './routes/_app/negotiations/sent'
import { Route as AppNegotiationsReceivedRouteImport } from './routes/_app/negotiations/received'
import { Route as AppNegotiationsHistoryRouteImport } from './routes/_app/negotiations/history'
import { Route as AppLoadsNewRouteImport } from './routes/_app/loads/new'
import { Route as AppLoadBoardIdRouteImport } from './routes/_app/load-board/$id'
import { Route as AppAdminSystemRouteImport } from './routes/_app/admin/system'
import { Route as AppAdminSupportTicketsRouteImport } from './routes/_app/admin/support-tickets'
import { Route as AppAdminProfileRouteImport } from './routes/_app/admin/profile'
import { Route as AppAdminGlobalSettingsRouteImport } from './routes/_app/admin/global-settings'
import { Route as AppAdminDashboardRouteImport } from './routes/_app/admin/dashboard'
import { Route as AppAccountSecurityRouteImport } from './routes/_app/account/security'
import { Route as AppAccountProfileRouteImport } from './routes/_app/account/profile'
import { Route as AppAccountPreferencesRouteImport } from './routes/_app/account/preferences'
import { Route as AppAccountNotificationsRouteImport } from './routes/_app/account/notifications'
import { Route as AppAdminTripsRouteRouteImport } from './routes/_app/admin/trips/route'
import { Route as AppAdminLoadsRouteRouteImport } from './routes/_app/admin/loads/route'
import { Route as AppAdminEntitiesRouteRouteImport } from './routes/_app/admin/entities/route'
import { Route as AppAdminApplicationsRouteRouteImport } from './routes/_app/admin/applications/route'
import { Route as AppLoadsIdIndexRouteImport } from './routes/_app/loads/$id/index'
import { Route as AppAdminTripsIndexRouteImport } from './routes/_app/admin/trips/index'
import { Route as AppAdminLoadsIndexRouteImport } from './routes/_app/admin/loads/index'
import { Route as AppAdminEntitiesIndexRouteImport } from './routes/_app/admin/entities/index'
import { Route as AppAdminApplicationsIndexRouteImport } from './routes/_app/admin/applications/index'
import { Route as AppLoadsIdEditRouteImport } from './routes/_app/loads/$id/edit'
import { Route as AppAdminTripsIdRouteImport } from './routes/_app/admin/trips/$id'
import { Route as AppAdminLoadsIdRouteImport } from './routes/_app/admin/loads/$id'
import { Route as AppAdminEntitiesIdRouteImport } from './routes/_app/admin/entities/$id'
import { Route as AppAdminCatalogsTruckTypesRouteImport } from './routes/_app/admin/catalogs/truck-types'
import { Route as AppAdminCatalogsTruckModelsRouteImport } from './routes/_app/admin/catalogs/truck-models'
import { Route as AppAdminCatalogsTruckManufacturersRouteImport } from './routes/_app/admin/catalogs/truck-manufacturers'
import { Route as AppAdminCatalogsTruckCatalogRouteImport } from './routes/_app/admin/catalogs/truck-catalog'
import { Route as AppAdminCatalogsTripEventPoliciesRouteImport } from './routes/_app/admin/catalogs/trip-event-policies'
import { Route as AppAdminCatalogsTrailerTypesRouteImport } from './routes/_app/admin/catalogs/trailer-types'
import { Route as AppAdminCatalogsTrailerLoadTypesRouteImport } from './routes/_app/admin/catalogs/trailer-load-types'
import { Route as AppAdminCatalogsLoadTypesRouteImport } from './routes/_app/admin/catalogs/load-types'
import { Route as AppAdminCatalogsLoadDocumentKindsRouteImport } from './routes/_app/admin/catalogs/load-document-kinds'
import { Route as AppAdminCatalogsDangerousCategoriesRouteImport } from './routes/_app/admin/catalogs/dangerous-categories'
import { Route as AppAdminCatalogsCurrenciesRouteImport } from './routes/_app/admin/catalogs/currencies'
import { Route as AppAdminCatalogsCountriesRouteImport } from './routes/_app/admin/catalogs/countries'
import { Route as AppAdminCatalogsAgreementTermsRouteImport } from './routes/_app/admin/catalogs/agreement-terms'
import { Route as AppAdminApplicationsIdRouteImport } from './routes/_app/admin/applications/$id'
import { Route as AppAdminLoadsIdTradesRouteImport } from './routes/_app/admin/loads/$id/trades'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const QrRouteRoute = QrRouteRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const QrCodeRoute = QrCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => QrRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppShippersRoute = AppShippersRouteImport.update({
  id: '/shippers',
  path: '/shippers',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppLoadBoardRoute = AppLoadBoardRouteImport.update({
  id: '/load-board',
  path: '/load-board',
  getParentRoute: () => AppRoute,
} as any)
const AppFleetRoute = AppFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AppRoute,
} as any)
const AppDriversRoute = AppDriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppCarriersRoute = AppCarriersRouteImport.update({
  id: '/carriers',
  path: '/carriers',
  getParentRoute: () => AppRoute,
} as any)
const AppApplyRoute = AppApplyRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => AppRoute,
} as any)
const AppApplicationStatusRoute = AppApplicationStatusRouteImport.update({
  id: '/application-status',
  path: '/application-status',
  getParentRoute: () => AppRoute,
} as any)
const AppAddressesRoute = AppAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AppRoute,
} as any)
const AppTripsRouteRoute = AppTripsRouteRouteImport.update({
  id: '/trips',
  path: '/trips',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRouteRoute = AppTicketsRouteRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRoute,
} as any)
const AppLoadsRouteRoute = AppLoadsRouteRouteImport.update({
  id: '/loads',
  path: '/loads',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRouteRoute = AppAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppTripsIndexRoute = AppTripsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTripsRouteRoute,
} as any)
const AppTicketsIndexRoute = AppTicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTicketsRouteRoute,
} as any)
const AppNegotiationsIndexRoute = AppNegotiationsIndexRouteImport.update({
  id: '/negotiations/',
  path: '/negotiations/',
  getParentRoute: () => AppRoute,
} as any)
const AppLoadsIndexRoute = AppLoadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoadsRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const LoadsIdAgreementRoute = LoadsIdAgreementRouteImport.update({
  id: '/loads/$id/agreement',
  path: '/loads/$id/agreement',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTripsShipperRoute = AppTripsShipperRouteImport.update({
  id: '/shipper',
  path: '/shipper',
  getParentRoute: () => AppTripsRouteRoute,
} as any)
const AppTripsCarrierRoute = AppTripsCarrierRouteImport.update({
  id: '/carrier',
  path: '/carrier',
  getParentRoute: () => AppTripsRouteRoute,
} as any)
const AppTripsIdRoute = AppTripsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppTripsRouteRoute,
} as any)
const AppTicketsIdRoute = AppTicketsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppTicketsRouteRoute,
} as any)
const AppNegotiationsSentRoute = AppNegotiationsSentRouteImport.update({
  id: '/negotiations/sent',
  path: '/negotiations/sent',
  getParentRoute: () => AppRoute,
} as any)
const AppNegotiationsReceivedRoute = AppNegotiationsReceivedRouteImport.update({
  id: '/negotiations/received',
  path: '/negotiations/received',
  getParentRoute: () => AppRoute,
} as any)
const AppNegotiationsHistoryRoute = AppNegotiationsHistoryRouteImport.update({
  id: '/negotiations/history',
  path: '/negotiations/history',
  getParentRoute: () => AppRoute,
} as any)
const AppLoadsNewRoute = AppLoadsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppLoadsRouteRoute,
} as any)
const AppLoadBoardIdRoute = AppLoadBoardIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppLoadBoardRoute,
} as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/admin/system',
  path: '/admin/system',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSupportTicketsRoute = AppAdminSupportTicketsRouteImport.update({
  id: '/admin/support-tickets',
  path: '/admin/support-tickets',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminProfileRoute = AppAdminProfileRouteImport.update({
  id: '/admin/profile',
  path: '/admin/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminGlobalSettingsRoute = AppAdminGlobalSettingsRouteImport.update({
  id: '/admin/global-settings',
  path: '/admin/global-settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminDashboardRoute = AppAdminDashboardRouteImport.update({
  id: '/admin/dashboard',
  path: '/admin/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountProfileRoute = AppAccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountPreferencesRoute = AppAccountPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountNotificationsRoute = AppAccountNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAdminTripsRouteRoute = AppAdminTripsRouteRouteImport.update({
  id: '/admin/trips',
  path: '/admin/trips',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLoadsRouteRoute = AppAdminLoadsRouteRouteImport.update({
  id: '/admin/loads',
  path: '/admin/loads',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminEntitiesRouteRoute = AppAdminEntitiesRouteRouteImport.update({
  id: '/admin/entities',
  path: '/admin/entities',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminApplicationsRouteRoute =
  AppAdminApplicationsRouteRouteImport.update({
    id: '/admin/applications',
    path: '/admin/applications',
    getParentRoute: () => AppRoute,
  } as any)
const AppLoadsIdIndexRoute = AppLoadsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppLoadsRouteRoute,
} as any)
const AppAdminTripsIndexRoute = AppAdminTripsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminTripsRouteRoute,
} as any)
const AppAdminLoadsIndexRoute = AppAdminLoadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminLoadsRouteRoute,
} as any)
const AppAdminEntitiesIndexRoute = AppAdminEntitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminEntitiesRouteRoute,
} as any)
const AppAdminApplicationsIndexRoute =
  AppAdminApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminApplicationsRouteRoute,
  } as any)
const AppLoadsIdEditRoute = AppLoadsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppLoadsRouteRoute,
} as any)
const AppAdminTripsIdRoute = AppAdminTripsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminTripsRouteRoute,
} as any)
const AppAdminLoadsIdRoute = AppAdminLoadsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminLoadsRouteRoute,
} as any)
const AppAdminEntitiesIdRoute = AppAdminEntitiesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminEntitiesRouteRoute,
} as any)
const AppAdminCatalogsTruckTypesRoute =
  AppAdminCatalogsTruckTypesRouteImport.update({
    id: '/admin/catalogs/truck-types',
    path: '/admin/catalogs/truck-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsTruckModelsRoute =
  AppAdminCatalogsTruckModelsRouteImport.update({
    id: '/admin/catalogs/truck-models',
    path: '/admin/catalogs/truck-models',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsTruckManufacturersRoute =
  AppAdminCatalogsTruckManufacturersRouteImport.update({
    id: '/admin/catalogs/truck-manufacturers',
    path: '/admin/catalogs/truck-manufacturers',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsTruckCatalogRoute =
  AppAdminCatalogsTruckCatalogRouteImport.update({
    id: '/admin/catalogs/truck-catalog',
    path: '/admin/catalogs/truck-catalog',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsTripEventPoliciesRoute =
  AppAdminCatalogsTripEventPoliciesRouteImport.update({
    id: '/admin/catalogs/trip-event-policies',
    path: '/admin/catalogs/trip-event-policies',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsTrailerTypesRoute =
  AppAdminCatalogsTrailerTypesRouteImport.update({
    id: '/admin/catalogs/trailer-types',
    path: '/admin/catalogs/trailer-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsTrailerLoadTypesRoute =
  AppAdminCatalogsTrailerLoadTypesRouteImport.update({
    id: '/admin/catalogs/trailer-load-types',
    path: '/admin/catalogs/trailer-load-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsLoadTypesRoute =
  AppAdminCatalogsLoadTypesRouteImport.update({
    id: '/admin/catalogs/load-types',
    path: '/admin/catalogs/load-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsLoadDocumentKindsRoute =
  AppAdminCatalogsLoadDocumentKindsRouteImport.update({
    id: '/admin/catalogs/load-document-kinds',
    path: '/admin/catalogs/load-document-kinds',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsDangerousCategoriesRoute =
  AppAdminCatalogsDangerousCategoriesRouteImport.update({
    id: '/admin/catalogs/dangerous-categories',
    path: '/admin/catalogs/dangerous-categories',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsCurrenciesRoute =
  AppAdminCatalogsCurrenciesRouteImport.update({
    id: '/admin/catalogs/currencies',
    path: '/admin/catalogs/currencies',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsCountriesRoute =
  AppAdminCatalogsCountriesRouteImport.update({
    id: '/admin/catalogs/countries',
    path: '/admin/catalogs/countries',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCatalogsAgreementTermsRoute =
  AppAdminCatalogsAgreementTermsRouteImport.update({
    id: '/admin/catalogs/agreement-terms',
    path: '/admin/catalogs/agreement-terms',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminApplicationsIdRoute = AppAdminApplicationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminApplicationsRouteRoute,
} as any)
const AppAdminLoadsIdTradesRoute = AppAdminLoadsIdTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => AppAdminLoadsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/qr': typeof QrRouteRouteWithChildren
  '/account': typeof AppAccountRouteRouteWithChildren
  '/loads': typeof AppLoadsRouteRouteWithChildren
  '/tickets': typeof AppTicketsRouteRouteWithChildren
  '/trips': typeof AppTripsRouteRouteWithChildren
  '/addresses': typeof AppAddressesRoute
  '/application-status': typeof AppApplicationStatusRoute
  '/apply': typeof AppApplyRoute
  '/carriers': typeof AppCarriersRoute
  '/contacts': typeof AppContactsRoute
  '/dashboard': typeof AppDashboardRoute
  '/drivers': typeof AppDriversRoute
  '/fleet': typeof AppFleetRoute
  '/load-board': typeof AppLoadBoardRouteWithChildren
  '/notifications': typeof AppNotificationsRoute
  '/shippers': typeof AppShippersRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/qr/$code': typeof QrCodeRoute
  '/admin/applications': typeof AppAdminApplicationsRouteRouteWithChildren
  '/admin/entities': typeof AppAdminEntitiesRouteRouteWithChildren
  '/admin/loads': typeof AppAdminLoadsRouteRouteWithChildren
  '/admin/trips': typeof AppAdminTripsRouteRouteWithChildren
  '/account/notifications': typeof AppAccountNotificationsRoute
  '/account/preferences': typeof AppAccountPreferencesRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/admin/dashboard': typeof AppAdminDashboardRoute
  '/admin/global-settings': typeof AppAdminGlobalSettingsRoute
  '/admin/profile': typeof AppAdminProfileRoute
  '/admin/support-tickets': typeof AppAdminSupportTicketsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/load-board/$id': typeof AppLoadBoardIdRoute
  '/loads/new': typeof AppLoadsNewRoute
  '/negotiations/history': typeof AppNegotiationsHistoryRoute
  '/negotiations/received': typeof AppNegotiationsReceivedRoute
  '/negotiations/sent': typeof AppNegotiationsSentRoute
  '/tickets/$id': typeof AppTicketsIdRoute
  '/trips/$id': typeof AppTripsIdRoute
  '/trips/carrier': typeof AppTripsCarrierRoute
  '/trips/shipper': typeof AppTripsShipperRoute
  '/loads/$id/agreement': typeof LoadsIdAgreementRoute
  '/account/': typeof AppAccountIndexRoute
  '/admin/': typeof AppAdminIndexRoute
  '/loads/': typeof AppLoadsIndexRoute
  '/negotiations/': typeof AppNegotiationsIndexRoute
  '/tickets/': typeof AppTicketsIndexRoute
  '/trips/': typeof AppTripsIndexRoute
  '/admin/applications/$id': typeof AppAdminApplicationsIdRoute
  '/admin/catalogs/agreement-terms': typeof AppAdminCatalogsAgreementTermsRoute
  '/admin/catalogs/countries': typeof AppAdminCatalogsCountriesRoute
  '/admin/catalogs/currencies': typeof AppAdminCatalogsCurrenciesRoute
  '/admin/catalogs/dangerous-categories': typeof AppAdminCatalogsDangerousCategoriesRoute
  '/admin/catalogs/load-document-kinds': typeof AppAdminCatalogsLoadDocumentKindsRoute
  '/admin/catalogs/load-types': typeof AppAdminCatalogsLoadTypesRoute
  '/admin/catalogs/trailer-load-types': typeof AppAdminCatalogsTrailerLoadTypesRoute
  '/admin/catalogs/trailer-types': typeof AppAdminCatalogsTrailerTypesRoute
  '/admin/catalogs/trip-event-policies': typeof AppAdminCatalogsTripEventPoliciesRoute
  '/admin/catalogs/truck-catalog': typeof AppAdminCatalogsTruckCatalogRoute
  '/admin/catalogs/truck-manufacturers': typeof AppAdminCatalogsTruckManufacturersRoute
  '/admin/catalogs/truck-models': typeof AppAdminCatalogsTruckModelsRoute
  '/admin/catalogs/truck-types': typeof AppAdminCatalogsTruckTypesRoute
  '/admin/entities/$id': typeof AppAdminEntitiesIdRoute
  '/admin/loads/$id': typeof AppAdminLoadsIdRouteWithChildren
  '/admin/trips/$id': typeof AppAdminTripsIdRoute
  '/loads/$id/edit': typeof AppLoadsIdEditRoute
  '/admin/applications/': typeof AppAdminApplicationsIndexRoute
  '/admin/entities/': typeof AppAdminEntitiesIndexRoute
  '/admin/loads/': typeof AppAdminLoadsIndexRoute
  '/admin/trips/': typeof AppAdminTripsIndexRoute
  '/loads/$id/': typeof AppLoadsIdIndexRoute
  '/admin/loads/$id/trades': typeof AppAdminLoadsIdTradesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/qr': typeof QrRouteRouteWithChildren
  '/addresses': typeof AppAddressesRoute
  '/application-status': typeof AppApplicationStatusRoute
  '/apply': typeof AppApplyRoute
  '/carriers': typeof AppCarriersRoute
  '/contacts': typeof AppContactsRoute
  '/dashboard': typeof AppDashboardRoute
  '/drivers': typeof AppDriversRoute
  '/fleet': typeof AppFleetRoute
  '/load-board': typeof AppLoadBoardRouteWithChildren
  '/notifications': typeof AppNotificationsRoute
  '/shippers': typeof AppShippersRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/qr/$code': typeof QrCodeRoute
  '/account/notifications': typeof AppAccountNotificationsRoute
  '/account/preferences': typeof AppAccountPreferencesRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/admin/dashboard': typeof AppAdminDashboardRoute
  '/admin/global-settings': typeof AppAdminGlobalSettingsRoute
  '/admin/profile': typeof AppAdminProfileRoute
  '/admin/support-tickets': typeof AppAdminSupportTicketsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/load-board/$id': typeof AppLoadBoardIdRoute
  '/loads/new': typeof AppLoadsNewRoute
  '/negotiations/history': typeof AppNegotiationsHistoryRoute
  '/negotiations/received': typeof AppNegotiationsReceivedRoute
  '/negotiations/sent': typeof AppNegotiationsSentRoute
  '/tickets/$id': typeof AppTicketsIdRoute
  '/trips/$id': typeof AppTripsIdRoute
  '/trips/carrier': typeof AppTripsCarrierRoute
  '/trips/shipper': typeof AppTripsShipperRoute
  '/loads/$id/agreement': typeof LoadsIdAgreementRoute
  '/account': typeof AppAccountIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/loads': typeof AppLoadsIndexRoute
  '/negotiations': typeof AppNegotiationsIndexRoute
  '/tickets': typeof AppTicketsIndexRoute
  '/trips': typeof AppTripsIndexRoute
  '/admin/applications/$id': typeof AppAdminApplicationsIdRoute
  '/admin/catalogs/agreement-terms': typeof AppAdminCatalogsAgreementTermsRoute
  '/admin/catalogs/countries': typeof AppAdminCatalogsCountriesRoute
  '/admin/catalogs/currencies': typeof AppAdminCatalogsCurrenciesRoute
  '/admin/catalogs/dangerous-categories': typeof AppAdminCatalogsDangerousCategoriesRoute
  '/admin/catalogs/load-document-kinds': typeof AppAdminCatalogsLoadDocumentKindsRoute
  '/admin/catalogs/load-types': typeof AppAdminCatalogsLoadTypesRoute
  '/admin/catalogs/trailer-load-types': typeof AppAdminCatalogsTrailerLoadTypesRoute
  '/admin/catalogs/trailer-types': typeof AppAdminCatalogsTrailerTypesRoute
  '/admin/catalogs/trip-event-policies': typeof AppAdminCatalogsTripEventPoliciesRoute
  '/admin/catalogs/truck-catalog': typeof AppAdminCatalogsTruckCatalogRoute
  '/admin/catalogs/truck-manufacturers': typeof AppAdminCatalogsTruckManufacturersRoute
  '/admin/catalogs/truck-models': typeof AppAdminCatalogsTruckModelsRoute
  '/admin/catalogs/truck-types': typeof AppAdminCatalogsTruckTypesRoute
  '/admin/entities/$id': typeof AppAdminEntitiesIdRoute
  '/admin/loads/$id': typeof AppAdminLoadsIdRouteWithChildren
  '/admin/trips/$id': typeof AppAdminTripsIdRoute
  '/loads/$id/edit': typeof AppLoadsIdEditRoute
  '/admin/applications': typeof AppAdminApplicationsIndexRoute
  '/admin/entities': typeof AppAdminEntitiesIndexRoute
  '/admin/loads': typeof AppAdminLoadsIndexRoute
  '/admin/trips': typeof AppAdminTripsIndexRoute
  '/loads/$id': typeof AppLoadsIdIndexRoute
  '/admin/loads/$id/trades': typeof AppAdminLoadsIdTradesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/qr': typeof QrRouteRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/account': typeof AppAccountRouteRouteWithChildren
  '/_app/loads': typeof AppLoadsRouteRouteWithChildren
  '/_app/tickets': typeof AppTicketsRouteRouteWithChildren
  '/_app/trips': typeof AppTripsRouteRouteWithChildren
  '/_app/addresses': typeof AppAddressesRoute
  '/_app/application-status': typeof AppApplicationStatusRoute
  '/_app/apply': typeof AppApplyRoute
  '/_app/carriers': typeof AppCarriersRoute
  '/_app/contacts': typeof AppContactsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/drivers': typeof AppDriversRoute
  '/_app/fleet': typeof AppFleetRoute
  '/_app/load-board': typeof AppLoadBoardRouteWithChildren
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/shippers': typeof AppShippersRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/qr/$code': typeof QrCodeRoute
  '/_app/admin/applications': typeof AppAdminApplicationsRouteRouteWithChildren
  '/_app/admin/entities': typeof AppAdminEntitiesRouteRouteWithChildren
  '/_app/admin/loads': typeof AppAdminLoadsRouteRouteWithChildren
  '/_app/admin/trips': typeof AppAdminTripsRouteRouteWithChildren
  '/_app/account/notifications': typeof AppAccountNotificationsRoute
  '/_app/account/preferences': typeof AppAccountPreferencesRoute
  '/_app/account/profile': typeof AppAccountProfileRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/admin/dashboard': typeof AppAdminDashboardRoute
  '/_app/admin/global-settings': typeof AppAdminGlobalSettingsRoute
  '/_app/admin/profile': typeof AppAdminProfileRoute
  '/_app/admin/support-tickets': typeof AppAdminSupportTicketsRoute
  '/_app/admin/system': typeof AppAdminSystemRoute
  '/_app/load-board/$id': typeof AppLoadBoardIdRoute
  '/_app/loads/new': typeof AppLoadsNewRoute
  '/_app/negotiations/history': typeof AppNegotiationsHistoryRoute
  '/_app/negotiations/received': typeof AppNegotiationsReceivedRoute
  '/_app/negotiations/sent': typeof AppNegotiationsSentRoute
  '/_app/tickets/$id': typeof AppTicketsIdRoute
  '/_app/trips/$id': typeof AppTripsIdRoute
  '/_app/trips/carrier': typeof AppTripsCarrierRoute
  '/_app/trips/shipper': typeof AppTripsShipperRoute
  '/loads/$id/agreement': typeof LoadsIdAgreementRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/loads/': typeof AppLoadsIndexRoute
  '/_app/negotiations/': typeof AppNegotiationsIndexRoute
  '/_app/tickets/': typeof AppTicketsIndexRoute
  '/_app/trips/': typeof AppTripsIndexRoute
  '/_app/admin/applications/$id': typeof AppAdminApplicationsIdRoute
  '/_app/admin/catalogs/agreement-terms': typeof AppAdminCatalogsAgreementTermsRoute
  '/_app/admin/catalogs/countries': typeof AppAdminCatalogsCountriesRoute
  '/_app/admin/catalogs/currencies': typeof AppAdminCatalogsCurrenciesRoute
  '/_app/admin/catalogs/dangerous-categories': typeof AppAdminCatalogsDangerousCategoriesRoute
  '/_app/admin/catalogs/load-document-kinds': typeof AppAdminCatalogsLoadDocumentKindsRoute
  '/_app/admin/catalogs/load-types': typeof AppAdminCatalogsLoadTypesRoute
  '/_app/admin/catalogs/trailer-load-types': typeof AppAdminCatalogsTrailerLoadTypesRoute
  '/_app/admin/catalogs/trailer-types': typeof AppAdminCatalogsTrailerTypesRoute
  '/_app/admin/catalogs/trip-event-policies': typeof AppAdminCatalogsTripEventPoliciesRoute
  '/_app/admin/catalogs/truck-catalog': typeof AppAdminCatalogsTruckCatalogRoute
  '/_app/admin/catalogs/truck-manufacturers': typeof AppAdminCatalogsTruckManufacturersRoute
  '/_app/admin/catalogs/truck-models': typeof AppAdminCatalogsTruckModelsRoute
  '/_app/admin/catalogs/truck-types': typeof AppAdminCatalogsTruckTypesRoute
  '/_app/admin/entities/$id': typeof AppAdminEntitiesIdRoute
  '/_app/admin/loads/$id': typeof AppAdminLoadsIdRouteWithChildren
  '/_app/admin/trips/$id': typeof AppAdminTripsIdRoute
  '/_app/loads/$id/edit': typeof AppLoadsIdEditRoute
  '/_app/admin/applications/': typeof AppAdminApplicationsIndexRoute
  '/_app/admin/entities/': typeof AppAdminEntitiesIndexRoute
  '/_app/admin/loads/': typeof AppAdminLoadsIndexRoute
  '/_app/admin/trips/': typeof AppAdminTripsIndexRoute
  '/_app/loads/$id/': typeof AppLoadsIdIndexRoute
  '/_app/admin/loads/$id/trades': typeof AppAdminLoadsIdTradesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/qr'
    | '/account'
    | '/loads'
    | '/tickets'
    | '/trips'
    | '/addresses'
    | '/application-status'
    | '/apply'
    | '/carriers'
    | '/contacts'
    | '/dashboard'
    | '/drivers'
    | '/fleet'
    | '/load-board'
    | '/notifications'
    | '/shippers'
    | '/login'
    | '/register'
    | '/qr/$code'
    | '/admin/applications'
    | '/admin/entities'
    | '/admin/loads'
    | '/admin/trips'
    | '/account/notifications'
    | '/account/preferences'
    | '/account/profile'
    | '/account/security'
    | '/admin/dashboard'
    | '/admin/global-settings'
    | '/admin/profile'
    | '/admin/support-tickets'
    | '/admin/system'
    | '/load-board/$id'
    | '/loads/new'
    | '/negotiations/history'
    | '/negotiations/received'
    | '/negotiations/sent'
    | '/tickets/$id'
    | '/trips/$id'
    | '/trips/carrier'
    | '/trips/shipper'
    | '/loads/$id/agreement'
    | '/account/'
    | '/admin/'
    | '/loads/'
    | '/negotiations/'
    | '/tickets/'
    | '/trips/'
    | '/admin/applications/$id'
    | '/admin/catalogs/agreement-terms'
    | '/admin/catalogs/countries'
    | '/admin/catalogs/currencies'
    | '/admin/catalogs/dangerous-categories'
    | '/admin/catalogs/load-document-kinds'
    | '/admin/catalogs/load-types'
    | '/admin/catalogs/trailer-load-types'
    | '/admin/catalogs/trailer-types'
    | '/admin/catalogs/trip-event-policies'
    | '/admin/catalogs/truck-catalog'
    | '/admin/catalogs/truck-manufacturers'
    | '/admin/catalogs/truck-models'
    | '/admin/catalogs/truck-types'
    | '/admin/entities/$id'
    | '/admin/loads/$id'
    | '/admin/trips/$id'
    | '/loads/$id/edit'
    | '/admin/applications/'
    | '/admin/entities/'
    | '/admin/loads/'
    | '/admin/trips/'
    | '/loads/$id/'
    | '/admin/loads/$id/trades'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/qr'
    | '/addresses'
    | '/application-status'
    | '/apply'
    | '/carriers'
    | '/contacts'
    | '/dashboard'
    | '/drivers'
    | '/fleet'
    | '/load-board'
    | '/notifications'
    | '/shippers'
    | '/login'
    | '/register'
    | '/qr/$code'
    | '/account/notifications'
    | '/account/preferences'
    | '/account/profile'
    | '/account/security'
    | '/admin/dashboard'
    | '/admin/global-settings'
    | '/admin/profile'
    | '/admin/support-tickets'
    | '/admin/system'
    | '/load-board/$id'
    | '/loads/new'
    | '/negotiations/history'
    | '/negotiations/received'
    | '/negotiations/sent'
    | '/tickets/$id'
    | '/trips/$id'
    | '/trips/carrier'
    | '/trips/shipper'
    | '/loads/$id/agreement'
    | '/account'
    | '/admin'
    | '/loads'
    | '/negotiations'
    | '/tickets'
    | '/trips'
    | '/admin/applications/$id'
    | '/admin/catalogs/agreement-terms'
    | '/admin/catalogs/countries'
    | '/admin/catalogs/currencies'
    | '/admin/catalogs/dangerous-categories'
    | '/admin/catalogs/load-document-kinds'
    | '/admin/catalogs/load-types'
    | '/admin/catalogs/trailer-load-types'
    | '/admin/catalogs/trailer-types'
    | '/admin/catalogs/trip-event-policies'
    | '/admin/catalogs/truck-catalog'
    | '/admin/catalogs/truck-manufacturers'
    | '/admin/catalogs/truck-models'
    | '/admin/catalogs/truck-types'
    | '/admin/entities/$id'
    | '/admin/loads/$id'
    | '/admin/trips/$id'
    | '/loads/$id/edit'
    | '/admin/applications'
    | '/admin/entities'
    | '/admin/loads'
    | '/admin/trips'
    | '/loads/$id'
    | '/admin/loads/$id/trades'
  id:
    | '__root__'
    | '/'
    | '/qr'
    | '/_app'
    | '/_auth'
    | '/_app/account'
    | '/_app/loads'
    | '/_app/tickets'
    | '/_app/trips'
    | '/_app/addresses'
    | '/_app/application-status'
    | '/_app/apply'
    | '/_app/carriers'
    | '/_app/contacts'
    | '/_app/dashboard'
    | '/_app/drivers'
    | '/_app/fleet'
    | '/_app/load-board'
    | '/_app/notifications'
    | '/_app/shippers'
    | '/_auth/login'
    | '/_auth/register'
    | '/qr/$code'
    | '/_app/admin/applications'
    | '/_app/admin/entities'
    | '/_app/admin/loads'
    | '/_app/admin/trips'
    | '/_app/account/notifications'
    | '/_app/account/preferences'
    | '/_app/account/profile'
    | '/_app/account/security'
    | '/_app/admin/dashboard'
    | '/_app/admin/global-settings'
    | '/_app/admin/profile'
    | '/_app/admin/support-tickets'
    | '/_app/admin/system'
    | '/_app/load-board/$id'
    | '/_app/loads/new'
    | '/_app/negotiations/history'
    | '/_app/negotiations/received'
    | '/_app/negotiations/sent'
    | '/_app/tickets/$id'
    | '/_app/trips/$id'
    | '/_app/trips/carrier'
    | '/_app/trips/shipper'
    | '/loads/$id/agreement'
    | '/_app/account/'
    | '/_app/admin/'
    | '/_app/loads/'
    | '/_app/negotiations/'
    | '/_app/tickets/'
    | '/_app/trips/'
    | '/_app/admin/applications/$id'
    | '/_app/admin/catalogs/agreement-terms'
    | '/_app/admin/catalogs/countries'
    | '/_app/admin/catalogs/currencies'
    | '/_app/admin/catalogs/dangerous-categories'
    | '/_app/admin/catalogs/load-document-kinds'
    | '/_app/admin/catalogs/load-types'
    | '/_app/admin/catalogs/trailer-load-types'
    | '/_app/admin/catalogs/trailer-types'
    | '/_app/admin/catalogs/trip-event-policies'
    | '/_app/admin/catalogs/truck-catalog'
    | '/_app/admin/catalogs/truck-manufacturers'
    | '/_app/admin/catalogs/truck-models'
    | '/_app/admin/catalogs/truck-types'
    | '/_app/admin/entities/$id'
    | '/_app/admin/loads/$id'
    | '/_app/admin/trips/$id'
    | '/_app/loads/$id/edit'
    | '/_app/admin/applications/'
    | '/_app/admin/entities/'
    | '/_app/admin/loads/'
    | '/_app/admin/trips/'
    | '/_app/loads/$id/'
    | '/_app/admin/loads/$id/trades'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  QrRouteRoute: typeof QrRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  LoadsIdAgreementRoute: typeof LoadsIdAgreementRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qr': {
      id: '/qr'
      path: '/qr'
      fullPath: '/qr'
      preLoaderRoute: typeof QrRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qr/$code': {
      id: '/qr/$code'
      path: '/$code'
      fullPath: '/qr/$code'
      preLoaderRoute: typeof QrCodeRouteImport
      parentRoute: typeof QrRouteRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/shippers': {
      id: '/_app/shippers'
      path: '/shippers'
      fullPath: '/shippers'
      preLoaderRoute: typeof AppShippersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/load-board': {
      id: '/_app/load-board'
      path: '/load-board'
      fullPath: '/load-board'
      preLoaderRoute: typeof AppLoadBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fleet': {
      id: '/_app/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof AppFleetRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drivers': {
      id: '/_app/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof AppDriversRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/carriers': {
      id: '/_app/carriers'
      path: '/carriers'
      fullPath: '/carriers'
      preLoaderRoute: typeof AppCarriersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apply': {
      id: '/_app/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof AppApplyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/application-status': {
      id: '/_app/application-status'
      path: '/application-status'
      fullPath: '/application-status'
      preLoaderRoute: typeof AppApplicationStatusRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/addresses': {
      id: '/_app/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AppAddressesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trips': {
      id: '/_app/trips'
      path: '/trips'
      fullPath: '/trips'
      preLoaderRoute: typeof AppTripsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loads': {
      id: '/_app/loads'
      path: '/loads'
      fullPath: '/loads'
      preLoaderRoute: typeof AppLoadsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trips/': {
      id: '/_app/trips/'
      path: '/'
      fullPath: '/trips/'
      preLoaderRoute: typeof AppTripsIndexRouteImport
      parentRoute: typeof AppTripsRouteRoute
    }
    '/_app/tickets/': {
      id: '/_app/tickets/'
      path: '/'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AppTicketsIndexRouteImport
      parentRoute: typeof AppTicketsRouteRoute
    }
    '/_app/negotiations/': {
      id: '/_app/negotiations/'
      path: '/negotiations'
      fullPath: '/negotiations/'
      preLoaderRoute: typeof AppNegotiationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loads/': {
      id: '/_app/loads/'
      path: '/'
      fullPath: '/loads/'
      preLoaderRoute: typeof AppLoadsIndexRouteImport
      parentRoute: typeof AppLoadsRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/loads/$id/agreement': {
      id: '/loads/$id/agreement'
      path: '/loads/$id/agreement'
      fullPath: '/loads/$id/agreement'
      preLoaderRoute: typeof LoadsIdAgreementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/trips/shipper': {
      id: '/_app/trips/shipper'
      path: '/shipper'
      fullPath: '/trips/shipper'
      preLoaderRoute: typeof AppTripsShipperRouteImport
      parentRoute: typeof AppTripsRouteRoute
    }
    '/_app/trips/carrier': {
      id: '/_app/trips/carrier'
      path: '/carrier'
      fullPath: '/trips/carrier'
      preLoaderRoute: typeof AppTripsCarrierRouteImport
      parentRoute: typeof AppTripsRouteRoute
    }
    '/_app/trips/$id': {
      id: '/_app/trips/$id'
      path: '/$id'
      fullPath: '/trips/$id'
      preLoaderRoute: typeof AppTripsIdRouteImport
      parentRoute: typeof AppTripsRouteRoute
    }
    '/_app/tickets/$id': {
      id: '/_app/tickets/$id'
      path: '/$id'
      fullPath: '/tickets/$id'
      preLoaderRoute: typeof AppTicketsIdRouteImport
      parentRoute: typeof AppTicketsRouteRoute
    }
    '/_app/negotiations/sent': {
      id: '/_app/negotiations/sent'
      path: '/negotiations/sent'
      fullPath: '/negotiations/sent'
      preLoaderRoute: typeof AppNegotiationsSentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/negotiations/received': {
      id: '/_app/negotiations/received'
      path: '/negotiations/received'
      fullPath: '/negotiations/received'
      preLoaderRoute: typeof AppNegotiationsReceivedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/negotiations/history': {
      id: '/_app/negotiations/history'
      path: '/negotiations/history'
      fullPath: '/negotiations/history'
      preLoaderRoute: typeof AppNegotiationsHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loads/new': {
      id: '/_app/loads/new'
      path: '/new'
      fullPath: '/loads/new'
      preLoaderRoute: typeof AppLoadsNewRouteImport
      parentRoute: typeof AppLoadsRouteRoute
    }
    '/_app/load-board/$id': {
      id: '/_app/load-board/$id'
      path: '/$id'
      fullPath: '/load-board/$id'
      preLoaderRoute: typeof AppLoadBoardIdRouteImport
      parentRoute: typeof AppLoadBoardRoute
    }
    '/_app/admin/system': {
      id: '/_app/admin/system'
      path: '/admin/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/support-tickets': {
      id: '/_app/admin/support-tickets'
      path: '/admin/support-tickets'
      fullPath: '/admin/support-tickets'
      preLoaderRoute: typeof AppAdminSupportTicketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/profile': {
      id: '/_app/admin/profile'
      path: '/admin/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AppAdminProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/global-settings': {
      id: '/_app/admin/global-settings'
      path: '/admin/global-settings'
      fullPath: '/admin/global-settings'
      preLoaderRoute: typeof AppAdminGlobalSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/dashboard': {
      id: '/_app/admin/dashboard'
      path: '/admin/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AppAdminDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/profile': {
      id: '/_app/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AppAccountProfileRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/preferences': {
      id: '/_app/account/preferences'
      path: '/preferences'
      fullPath: '/account/preferences'
      preLoaderRoute: typeof AppAccountPreferencesRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/account/notifications': {
      id: '/_app/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AppAccountNotificationsRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/_app/admin/trips': {
      id: '/_app/admin/trips'
      path: '/admin/trips'
      fullPath: '/admin/trips'
      preLoaderRoute: typeof AppAdminTripsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/loads': {
      id: '/_app/admin/loads'
      path: '/admin/loads'
      fullPath: '/admin/loads'
      preLoaderRoute: typeof AppAdminLoadsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/entities': {
      id: '/_app/admin/entities'
      path: '/admin/entities'
      fullPath: '/admin/entities'
      preLoaderRoute: typeof AppAdminEntitiesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/applications': {
      id: '/_app/admin/applications'
      path: '/admin/applications'
      fullPath: '/admin/applications'
      preLoaderRoute: typeof AppAdminApplicationsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loads/$id/': {
      id: '/_app/loads/$id/'
      path: '/$id'
      fullPath: '/loads/$id/'
      preLoaderRoute: typeof AppLoadsIdIndexRouteImport
      parentRoute: typeof AppLoadsRouteRoute
    }
    '/_app/admin/trips/': {
      id: '/_app/admin/trips/'
      path: '/'
      fullPath: '/admin/trips/'
      preLoaderRoute: typeof AppAdminTripsIndexRouteImport
      parentRoute: typeof AppAdminTripsRouteRoute
    }
    '/_app/admin/loads/': {
      id: '/_app/admin/loads/'
      path: '/'
      fullPath: '/admin/loads/'
      preLoaderRoute: typeof AppAdminLoadsIndexRouteImport
      parentRoute: typeof AppAdminLoadsRouteRoute
    }
    '/_app/admin/entities/': {
      id: '/_app/admin/entities/'
      path: '/'
      fullPath: '/admin/entities/'
      preLoaderRoute: typeof AppAdminEntitiesIndexRouteImport
      parentRoute: typeof AppAdminEntitiesRouteRoute
    }
    '/_app/admin/applications/': {
      id: '/_app/admin/applications/'
      path: '/'
      fullPath: '/admin/applications/'
      preLoaderRoute: typeof AppAdminApplicationsIndexRouteImport
      parentRoute: typeof AppAdminApplicationsRouteRoute
    }
    '/_app/loads/$id/edit': {
      id: '/_app/loads/$id/edit'
      path: '/$id/edit'
      fullPath: '/loads/$id/edit'
      preLoaderRoute: typeof AppLoadsIdEditRouteImport
      parentRoute: typeof AppLoadsRouteRoute
    }
    '/_app/admin/trips/$id': {
      id: '/_app/admin/trips/$id'
      path: '/$id'
      fullPath: '/admin/trips/$id'
      preLoaderRoute: typeof AppAdminTripsIdRouteImport
      parentRoute: typeof AppAdminTripsRouteRoute
    }
    '/_app/admin/loads/$id': {
      id: '/_app/admin/loads/$id'
      path: '/$id'
      fullPath: '/admin/loads/$id'
      preLoaderRoute: typeof AppAdminLoadsIdRouteImport
      parentRoute: typeof AppAdminLoadsRouteRoute
    }
    '/_app/admin/entities/$id': {
      id: '/_app/admin/entities/$id'
      path: '/$id'
      fullPath: '/admin/entities/$id'
      preLoaderRoute: typeof AppAdminEntitiesIdRouteImport
      parentRoute: typeof AppAdminEntitiesRouteRoute
    }
    '/_app/admin/catalogs/truck-types': {
      id: '/_app/admin/catalogs/truck-types'
      path: '/admin/catalogs/truck-types'
      fullPath: '/admin/catalogs/truck-types'
      preLoaderRoute: typeof AppAdminCatalogsTruckTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/truck-models': {
      id: '/_app/admin/catalogs/truck-models'
      path: '/admin/catalogs/truck-models'
      fullPath: '/admin/catalogs/truck-models'
      preLoaderRoute: typeof AppAdminCatalogsTruckModelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/truck-manufacturers': {
      id: '/_app/admin/catalogs/truck-manufacturers'
      path: '/admin/catalogs/truck-manufacturers'
      fullPath: '/admin/catalogs/truck-manufacturers'
      preLoaderRoute: typeof AppAdminCatalogsTruckManufacturersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/truck-catalog': {
      id: '/_app/admin/catalogs/truck-catalog'
      path: '/admin/catalogs/truck-catalog'
      fullPath: '/admin/catalogs/truck-catalog'
      preLoaderRoute: typeof AppAdminCatalogsTruckCatalogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/trip-event-policies': {
      id: '/_app/admin/catalogs/trip-event-policies'
      path: '/admin/catalogs/trip-event-policies'
      fullPath: '/admin/catalogs/trip-event-policies'
      preLoaderRoute: typeof AppAdminCatalogsTripEventPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/trailer-types': {
      id: '/_app/admin/catalogs/trailer-types'
      path: '/admin/catalogs/trailer-types'
      fullPath: '/admin/catalogs/trailer-types'
      preLoaderRoute: typeof AppAdminCatalogsTrailerTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/trailer-load-types': {
      id: '/_app/admin/catalogs/trailer-load-types'
      path: '/admin/catalogs/trailer-load-types'
      fullPath: '/admin/catalogs/trailer-load-types'
      preLoaderRoute: typeof AppAdminCatalogsTrailerLoadTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/load-types': {
      id: '/_app/admin/catalogs/load-types'
      path: '/admin/catalogs/load-types'
      fullPath: '/admin/catalogs/load-types'
      preLoaderRoute: typeof AppAdminCatalogsLoadTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/load-document-kinds': {
      id: '/_app/admin/catalogs/load-document-kinds'
      path: '/admin/catalogs/load-document-kinds'
      fullPath: '/admin/catalogs/load-document-kinds'
      preLoaderRoute: typeof AppAdminCatalogsLoadDocumentKindsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/dangerous-categories': {
      id: '/_app/admin/catalogs/dangerous-categories'
      path: '/admin/catalogs/dangerous-categories'
      fullPath: '/admin/catalogs/dangerous-categories'
      preLoaderRoute: typeof AppAdminCatalogsDangerousCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/currencies': {
      id: '/_app/admin/catalogs/currencies'
      path: '/admin/catalogs/currencies'
      fullPath: '/admin/catalogs/currencies'
      preLoaderRoute: typeof AppAdminCatalogsCurrenciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/countries': {
      id: '/_app/admin/catalogs/countries'
      path: '/admin/catalogs/countries'
      fullPath: '/admin/catalogs/countries'
      preLoaderRoute: typeof AppAdminCatalogsCountriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/catalogs/agreement-terms': {
      id: '/_app/admin/catalogs/agreement-terms'
      path: '/admin/catalogs/agreement-terms'
      fullPath: '/admin/catalogs/agreement-terms'
      preLoaderRoute: typeof AppAdminCatalogsAgreementTermsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/applications/$id': {
      id: '/_app/admin/applications/$id'
      path: '/$id'
      fullPath: '/admin/applications/$id'
      preLoaderRoute: typeof AppAdminApplicationsIdRouteImport
      parentRoute: typeof AppAdminApplicationsRouteRoute
    }
    '/_app/admin/loads/$id/trades': {
      id: '/_app/admin/loads/$id/trades'
      path: '/trades'
      fullPath: '/admin/loads/$id/trades'
      preLoaderRoute: typeof AppAdminLoadsIdTradesRouteImport
      parentRoute: typeof AppAdminLoadsIdRoute
    }
  }
}

interface QrRouteRouteChildren {
  QrCodeRoute: typeof QrCodeRoute
}

const QrRouteRouteChildren: QrRouteRouteChildren = {
  QrCodeRoute: QrCodeRoute,
}

const QrRouteRouteWithChildren =
  QrRouteRoute._addFileChildren(QrRouteRouteChildren)

interface AppAccountRouteRouteChildren {
  AppAccountNotificationsRoute: typeof AppAccountNotificationsRoute
  AppAccountPreferencesRoute: typeof AppAccountPreferencesRoute
  AppAccountProfileRoute: typeof AppAccountProfileRoute
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
}

const AppAccountRouteRouteChildren: AppAccountRouteRouteChildren = {
  AppAccountNotificationsRoute: AppAccountNotificationsRoute,
  AppAccountPreferencesRoute: AppAccountPreferencesRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAccountSecurityRoute: AppAccountSecurityRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
}

const AppAccountRouteRouteWithChildren = AppAccountRouteRoute._addFileChildren(
  AppAccountRouteRouteChildren,
)

interface AppLoadsRouteRouteChildren {
  AppLoadsNewRoute: typeof AppLoadsNewRoute
  AppLoadsIndexRoute: typeof AppLoadsIndexRoute
  AppLoadsIdEditRoute: typeof AppLoadsIdEditRoute
  AppLoadsIdIndexRoute: typeof AppLoadsIdIndexRoute
}

const AppLoadsRouteRouteChildren: AppLoadsRouteRouteChildren = {
  AppLoadsNewRoute: AppLoadsNewRoute,
  AppLoadsIndexRoute: AppLoadsIndexRoute,
  AppLoadsIdEditRoute: AppLoadsIdEditRoute,
  AppLoadsIdIndexRoute: AppLoadsIdIndexRoute,
}

const AppLoadsRouteRouteWithChildren = AppLoadsRouteRoute._addFileChildren(
  AppLoadsRouteRouteChildren,
)

interface AppTicketsRouteRouteChildren {
  AppTicketsIdRoute: typeof AppTicketsIdRoute
  AppTicketsIndexRoute: typeof AppTicketsIndexRoute
}

const AppTicketsRouteRouteChildren: AppTicketsRouteRouteChildren = {
  AppTicketsIdRoute: AppTicketsIdRoute,
  AppTicketsIndexRoute: AppTicketsIndexRoute,
}

const AppTicketsRouteRouteWithChildren = AppTicketsRouteRoute._addFileChildren(
  AppTicketsRouteRouteChildren,
)

interface AppTripsRouteRouteChildren {
  AppTripsIdRoute: typeof AppTripsIdRoute
  AppTripsCarrierRoute: typeof AppTripsCarrierRoute
  AppTripsShipperRoute: typeof AppTripsShipperRoute
  AppTripsIndexRoute: typeof AppTripsIndexRoute
}

const AppTripsRouteRouteChildren: AppTripsRouteRouteChildren = {
  AppTripsIdRoute: AppTripsIdRoute,
  AppTripsCarrierRoute: AppTripsCarrierRoute,
  AppTripsShipperRoute: AppTripsShipperRoute,
  AppTripsIndexRoute: AppTripsIndexRoute,
}

const AppTripsRouteRouteWithChildren = AppTripsRouteRoute._addFileChildren(
  AppTripsRouteRouteChildren,
)

interface AppLoadBoardRouteChildren {
  AppLoadBoardIdRoute: typeof AppLoadBoardIdRoute
}

const AppLoadBoardRouteChildren: AppLoadBoardRouteChildren = {
  AppLoadBoardIdRoute: AppLoadBoardIdRoute,
}

const AppLoadBoardRouteWithChildren = AppLoadBoardRoute._addFileChildren(
  AppLoadBoardRouteChildren,
)

interface AppAdminApplicationsRouteRouteChildren {
  AppAdminApplicationsIdRoute: typeof AppAdminApplicationsIdRoute
  AppAdminApplicationsIndexRoute: typeof AppAdminApplicationsIndexRoute
}

const AppAdminApplicationsRouteRouteChildren: AppAdminApplicationsRouteRouteChildren =
  {
    AppAdminApplicationsIdRoute: AppAdminApplicationsIdRoute,
    AppAdminApplicationsIndexRoute: AppAdminApplicationsIndexRoute,
  }

const AppAdminApplicationsRouteRouteWithChildren =
  AppAdminApplicationsRouteRoute._addFileChildren(
    AppAdminApplicationsRouteRouteChildren,
  )

interface AppAdminEntitiesRouteRouteChildren {
  AppAdminEntitiesIdRoute: typeof AppAdminEntitiesIdRoute
  AppAdminEntitiesIndexRoute: typeof AppAdminEntitiesIndexRoute
}

const AppAdminEntitiesRouteRouteChildren: AppAdminEntitiesRouteRouteChildren = {
  AppAdminEntitiesIdRoute: AppAdminEntitiesIdRoute,
  AppAdminEntitiesIndexRoute: AppAdminEntitiesIndexRoute,
}

const AppAdminEntitiesRouteRouteWithChildren =
  AppAdminEntitiesRouteRoute._addFileChildren(
    AppAdminEntitiesRouteRouteChildren,
  )

interface AppAdminLoadsIdRouteChildren {
  AppAdminLoadsIdTradesRoute: typeof AppAdminLoadsIdTradesRoute
}

const AppAdminLoadsIdRouteChildren: AppAdminLoadsIdRouteChildren = {
  AppAdminLoadsIdTradesRoute: AppAdminLoadsIdTradesRoute,
}

const AppAdminLoadsIdRouteWithChildren = AppAdminLoadsIdRoute._addFileChildren(
  AppAdminLoadsIdRouteChildren,
)

interface AppAdminLoadsRouteRouteChildren {
  AppAdminLoadsIdRoute: typeof AppAdminLoadsIdRouteWithChildren
  AppAdminLoadsIndexRoute: typeof AppAdminLoadsIndexRoute
}

const AppAdminLoadsRouteRouteChildren: AppAdminLoadsRouteRouteChildren = {
  AppAdminLoadsIdRoute: AppAdminLoadsIdRouteWithChildren,
  AppAdminLoadsIndexRoute: AppAdminLoadsIndexRoute,
}

const AppAdminLoadsRouteRouteWithChildren =
  AppAdminLoadsRouteRoute._addFileChildren(AppAdminLoadsRouteRouteChildren)

interface AppAdminTripsRouteRouteChildren {
  AppAdminTripsIdRoute: typeof AppAdminTripsIdRoute
  AppAdminTripsIndexRoute: typeof AppAdminTripsIndexRoute
}

const AppAdminTripsRouteRouteChildren: AppAdminTripsRouteRouteChildren = {
  AppAdminTripsIdRoute: AppAdminTripsIdRoute,
  AppAdminTripsIndexRoute: AppAdminTripsIndexRoute,
}

const AppAdminTripsRouteRouteWithChildren =
  AppAdminTripsRouteRoute._addFileChildren(AppAdminTripsRouteRouteChildren)

interface AppRouteChildren {
  AppAccountRouteRoute: typeof AppAccountRouteRouteWithChildren
  AppLoadsRouteRoute: typeof AppLoadsRouteRouteWithChildren
  AppTicketsRouteRoute: typeof AppTicketsRouteRouteWithChildren
  AppTripsRouteRoute: typeof AppTripsRouteRouteWithChildren
  AppAddressesRoute: typeof AppAddressesRoute
  AppApplicationStatusRoute: typeof AppApplicationStatusRoute
  AppApplyRoute: typeof AppApplyRoute
  AppCarriersRoute: typeof AppCarriersRoute
  AppContactsRoute: typeof AppContactsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDriversRoute: typeof AppDriversRoute
  AppFleetRoute: typeof AppFleetRoute
  AppLoadBoardRoute: typeof AppLoadBoardRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppShippersRoute: typeof AppShippersRoute
  AppAdminApplicationsRouteRoute: typeof AppAdminApplicationsRouteRouteWithChildren
  AppAdminEntitiesRouteRoute: typeof AppAdminEntitiesRouteRouteWithChildren
  AppAdminLoadsRouteRoute: typeof AppAdminLoadsRouteRouteWithChildren
  AppAdminTripsRouteRoute: typeof AppAdminTripsRouteRouteWithChildren
  AppAdminDashboardRoute: typeof AppAdminDashboardRoute
  AppAdminGlobalSettingsRoute: typeof AppAdminGlobalSettingsRoute
  AppAdminProfileRoute: typeof AppAdminProfileRoute
  AppAdminSupportTicketsRoute: typeof AppAdminSupportTicketsRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppNegotiationsHistoryRoute: typeof AppNegotiationsHistoryRoute
  AppNegotiationsReceivedRoute: typeof AppNegotiationsReceivedRoute
  AppNegotiationsSentRoute: typeof AppNegotiationsSentRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppNegotiationsIndexRoute: typeof AppNegotiationsIndexRoute
  AppAdminCatalogsAgreementTermsRoute: typeof AppAdminCatalogsAgreementTermsRoute
  AppAdminCatalogsCountriesRoute: typeof AppAdminCatalogsCountriesRoute
  AppAdminCatalogsCurrenciesRoute: typeof AppAdminCatalogsCurrenciesRoute
  AppAdminCatalogsDangerousCategoriesRoute: typeof AppAdminCatalogsDangerousCategoriesRoute
  AppAdminCatalogsLoadDocumentKindsRoute: typeof AppAdminCatalogsLoadDocumentKindsRoute
  AppAdminCatalogsLoadTypesRoute: typeof AppAdminCatalogsLoadTypesRoute
  AppAdminCatalogsTrailerLoadTypesRoute: typeof AppAdminCatalogsTrailerLoadTypesRoute
  AppAdminCatalogsTrailerTypesRoute: typeof AppAdminCatalogsTrailerTypesRoute
  AppAdminCatalogsTripEventPoliciesRoute: typeof AppAdminCatalogsTripEventPoliciesRoute
  AppAdminCatalogsTruckCatalogRoute: typeof AppAdminCatalogsTruckCatalogRoute
  AppAdminCatalogsTruckManufacturersRoute: typeof AppAdminCatalogsTruckManufacturersRoute
  AppAdminCatalogsTruckModelsRoute: typeof AppAdminCatalogsTruckModelsRoute
  AppAdminCatalogsTruckTypesRoute: typeof AppAdminCatalogsTruckTypesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRouteRoute: AppAccountRouteRouteWithChildren,
  AppLoadsRouteRoute: AppLoadsRouteRouteWithChildren,
  AppTicketsRouteRoute: AppTicketsRouteRouteWithChildren,
  AppTripsRouteRoute: AppTripsRouteRouteWithChildren,
  AppAddressesRoute: AppAddressesRoute,
  AppApplicationStatusRoute: AppApplicationStatusRoute,
  AppApplyRoute: AppApplyRoute,
  AppCarriersRoute: AppCarriersRoute,
  AppContactsRoute: AppContactsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDriversRoute: AppDriversRoute,
  AppFleetRoute: AppFleetRoute,
  AppLoadBoardRoute: AppLoadBoardRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppShippersRoute: AppShippersRoute,
  AppAdminApplicationsRouteRoute: AppAdminApplicationsRouteRouteWithChildren,
  AppAdminEntitiesRouteRoute: AppAdminEntitiesRouteRouteWithChildren,
  AppAdminLoadsRouteRoute: AppAdminLoadsRouteRouteWithChildren,
  AppAdminTripsRouteRoute: AppAdminTripsRouteRouteWithChildren,
  AppAdminDashboardRoute: AppAdminDashboardRoute,
  AppAdminGlobalSettingsRoute: AppAdminGlobalSettingsRoute,
  AppAdminProfileRoute: AppAdminProfileRoute,
  AppAdminSupportTicketsRoute: AppAdminSupportTicketsRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppNegotiationsHistoryRoute: AppNegotiationsHistoryRoute,
  AppNegotiationsReceivedRoute: AppNegotiationsReceivedRoute,
  AppNegotiationsSentRoute: AppNegotiationsSentRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppNegotiationsIndexRoute: AppNegotiationsIndexRoute,
  AppAdminCatalogsAgreementTermsRoute: AppAdminCatalogsAgreementTermsRoute,
  AppAdminCatalogsCountriesRoute: AppAdminCatalogsCountriesRoute,
  AppAdminCatalogsCurrenciesRoute: AppAdminCatalogsCurrenciesRoute,
  AppAdminCatalogsDangerousCategoriesRoute:
    AppAdminCatalogsDangerousCategoriesRoute,
  AppAdminCatalogsLoadDocumentKindsRoute:
    AppAdminCatalogsLoadDocumentKindsRoute,
  AppAdminCatalogsLoadTypesRoute: AppAdminCatalogsLoadTypesRoute,
  AppAdminCatalogsTrailerLoadTypesRoute: AppAdminCatalogsTrailerLoadTypesRoute,
  AppAdminCatalogsTrailerTypesRoute: AppAdminCatalogsTrailerTypesRoute,
  AppAdminCatalogsTripEventPoliciesRoute:
    AppAdminCatalogsTripEventPoliciesRoute,
  AppAdminCatalogsTruckCatalogRoute: AppAdminCatalogsTruckCatalogRoute,
  AppAdminCatalogsTruckManufacturersRoute:
    AppAdminCatalogsTruckManufacturersRoute,
  AppAdminCatalogsTruckModelsRoute: AppAdminCatalogsTruckModelsRoute,
  AppAdminCatalogsTruckTypesRoute: AppAdminCatalogsTruckTypesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  QrRouteRoute: QrRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  LoadsIdAgreementRoute: LoadsIdAgreementRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
